(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.vhCheck = factory();
  }
}(this, function () {
  'use strict';

  var prevOffset = 0;

  function testVh() {
    // Assign to body (vs. html?)
    var container = document.documentElement; // document.body; // document.documentElement
    // test with fixed
    var fixedTest = document.createElement('div');
    fixedTest.style.cssText = 'position: fixed; top: 0; left: 0; bottom: 0;';
    container.insertBefore(fixedTest, container.firstChild);
    // test with vh
    var vhTest = document.createElement('div');
    vhTest.style.cssText = 'position: fixed; top: 0; left: 0; height: 100vh;';
    container.insertBefore(vhTest, container.firstChild);
    // in iOS vh will be bigger
    var topBottom = fixedTest.offsetHeight;
    var vh        = vhTest.offsetHeight;
    var offset    = vh - topBottom;
    var newOffset = offset; // prevOffset > offset ? prevOffset : offset;
    prevOffset = newOffset;

    // clean
    container.removeChild(fixedTest);
    container.removeChild(vhTest);

    return newOffset;
  }

  function updateCssVar(cssVarName, offset) {
    document.documentElement.style.setProperty('--' + cssVarName, offset + 'px');
  }

  return function vhCheck(cssVarName) {
    // configurable CSS var
    cssVarName = typeof cssVarName === 'string' ? cssVarName : 'vh-offset';

    var offset = testVh();
    // Listen for orientation changes
    window.addEventListener('orientationchange', function() {
      setTimeout(function(){
        var newOffset = testVh();
        updateCssVar(cssVarName, newOffset);
      }, 750);
    }, false);
    // usefullness check
    if (!offset) return false;
    updateCssVar(cssVarName, offset);
    return true;
  }
}));
